const styles = theme => ({
  listItemContainer: {
    background: theme.palette.primary.white,
    display: 'block',
    padding: '16px 24px',
    border: `1px solid ${theme.palette.primary.borderColor}`,
    borderRadius: '0px',
    '&:hover': {
      border: `1px solid ${theme.palette.primary.cardHoverBorder}`,
      background: theme.palette.primary.cardHover,
    },
    '&:focus': {
      background: theme.palette.primary.cardHover,
      border: `1px solid ${theme.palette.primary.cardHoverBorder}`,
    },
    [theme.breakpoints.down('sm')]: {
      padding: '16px',
    },
  },
  listItemContainerChecked: {
    background: theme.palette.primary.cardHover,
  },
  listItemContainerDisabled: {
    background: theme.palette.primary.grey,
    pointerEvents: 'none',
    opacity: '1 !important',
  },

  listItemHeader: {
    paddingBottom: '16px',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'center',
      gap: '16px',
      paddingBottom: 0,
    },
  },

  listItemTitleWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    position: 'relative',
    gap: '16px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'center',

      '& $chip': {
        position: 'absolute',
        right: '0',
      },
    },
  },
  listItemTitle: {
    display: 'flex',
    alignItems: 'center',
  },

  itemCheckbox: {
    '& svg': {
      height: '30px',
      width: '30px',
    },
  },
  itemCheckboxChecked: {
    color: `${theme.palette.primary.main} !important`,
  },
  itemCheckboxIndeterminate: {
    color: '#1FCACC !important',
  },

  titleText: {
    color: theme.palette.primary.adgmBlack,
    fontWeight: 600,
    fontSize: '16px',
    lineHeight: '21px',
  },

  chip: {
    display: 'inline-block',
    background: theme.palette.primary.adgmGreen,
    color: theme.palette.primary.white,
    padding: '3px 12px',
    fontWeight: 500,
    fontSize: '12px',
    borderRadius: '0px',
  },

  propertyInfoList: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '8px',
    flexWrap: 'wrap',
    [theme.breakpoints.up('md')]: {
      marginTop: '8px',
    },
  },
  propertyInfoContainer: {
    display: 'inline-flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  propertyInfoIcon: {
    marginRight: '8px',
  },
  propertyInfoText: {
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '21px',
    whiteSpace: 'nowrap',
  },

  addressContainer: {},
  addressLabel: {
    color: theme.palette.secondary.dim,
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '18px',
  },
  addressData: {
    color: theme.palette.primary.adgmBlack,
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '21px',
  },
  summaryContainer: {
    borderTop: `1px solid ${theme.palette.primary.borderColor}`,
    paddingTop: '16px',
    display: 'flex',
    alignItems: 'flex-start',
    flexWrap: 'wrap',
    gap: '20px',
  },
  summaryItem: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  summaryItemLabel: {
    color: theme.palette.secondary.dim,
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '18px',
  },
  summaryItemValue: {
    color: theme.palette.primary.adgmBlack,
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '21px',
  },

  errorAlert: {
    width: '100%',
    marginTop: '16px',
    alignItems: 'center',
  },

  errorContainer: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '16px',
  },

  errorsList: {},

  errorText: {
    color: theme.palette.primary.adgmBlack,
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '18px',
  },

  errorActionBtn: {
    background: `transparent !important`,
    color: theme.palette.primary.adgmSkyBlue,
    fontWeight: 500,
    fontSize: '12px',
    lineHeight: '18px',
    padding: 0,
    marginLeft: '4px',
    whiteSpace: 'nowrap',
    textTransform: 'lowercase',
    '& ::first-letter': {
      textTransform: 'uppercase',
    },
  },
});

export default styles;
